import { IContactAddress, initialState } from './initialState';

export enum EContactDetailTypes {
    SET_INIT = '@contactAddress/SET_INIT',
    FILL_ADDRESS = '@contactAddress/FILL_ADDRESS',
    SET_VERIFIED_ADDRESS = '@contactAddress/SET_VERIFIED_ADDRESS',
    SET_EDIT = '@contactAddress/SET_EDIT',
    CHANGE_IS_AGREE = '@contactAddress/CHANGE_IS_AGREE',
    RESET_DATA = '@contactAddress/RESET_DATA',
    SET_ERROR = '@contactAddress/SET_ERROR',
    SET_CALLED_CHECK = '@contactAddress/SET_CALLED_CHECK',
}

export type TSetInit = {
    type: EContactDetailTypes.SET_INIT,
    payload: IContactAddress,
}

export type TResetData = {
    type: EContactDetailTypes.RESET_DATA,
    payload: IContactAddress,
}

export type TFillAddressAction = {
    type: EContactDetailTypes.FILL_ADDRESS,
    payload: Pick<IContactAddress, 'editedAddressData'>,
}

export type TSetAddressVerifiationAction = {
    type: EContactDetailTypes.SET_VERIFIED_ADDRESS,
    payload: Pick<IContactAddress, 'verifiedAddressData'>,
}

export type TSetAddressEdit = {
    type: EContactDetailTypes.SET_EDIT,
    payload: Pick<IContactAddress, 'isEdit'>,
}

export type TSetAddressCheckCalled = {
    type: EContactDetailTypes.SET_CALLED_CHECK,
    payload: Pick<IContactAddress, 'wasCheckCalled'>,
}

export type TChangeIsAgree = {
    type: EContactDetailTypes.CHANGE_IS_AGREE,
    payload: Pick<IContactAddress, 'isAgree'>,
}

export type TSetError = {
    type: EContactDetailTypes.SET_ERROR,
    payload: string | undefined,
}

export type ContactDetailsActions =
    | TSetInit
    | TSetAddressCheckCalled
    | TFillAddressAction
    | TSetAddressVerifiationAction
    | TSetAddressEdit
    | TResetData
    | TChangeIsAgree
    | TSetError;

// eslint-disable-next-line default-param-last
const contactAddressReducer = (state: IContactAddress = initialState, action: ContactDetailsActions): IContactAddress => {
    switch (action.type) {
        case EContactDetailTypes.SET_INIT:
        case EContactDetailTypes.FILL_ADDRESS:
        case EContactDetailTypes.SET_VERIFIED_ADDRESS:
        case EContactDetailTypes.SET_EDIT:
        case EContactDetailTypes.SET_CALLED_CHECK:
        case EContactDetailTypes.CHANGE_IS_AGREE:
        case EContactDetailTypes.RESET_DATA: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case EContactDetailTypes.SET_ERROR:
            return {
                ...state,
                verifiedAddressData: {
                    ...state.verifiedAddressData,
                    error: action.payload,
                },
            };
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};

export default contactAddressReducer;
